import React, { useEffect, useState } from 'react';

import { Form, Input, Modal } from 'antd';
import styled from 'styled-components';

import Button from 'components/lib/Button';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 30px 30px 20px 30px;
`;

const StyledModal = styled(Modal)`
  &&& {
    .ant-modal-content {
      padding: 0px;
      line-height: 1;
      border-radius: 1px;
      user-select: none;
      width: 540px;
      margin-top: 200px;
    }
    .ant-modal-body {
      padding: 0px;
      line-height: normal;
    }
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.span`
  font-size: 20px;
  font-family: var(--font-bold);
  color: var(--text-primary);
`;

const Subtitle = styled.span`
  font-size: 14px;
  color: var(--text-secondary);
  > span {
    color: var(--text-primary);
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

const Info = styled.span`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: var(--text-secondary);
`;

const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Field = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Label = styled.div`
  font-family: var(--font-bold);
  font-size: 14px;
  text-align: right;
  min-width: 137px;
  color: var(--text-primary);
`;

const Footer = styled.div`
  display: flex;
  border-top: 1px solid var(--line-gray);
  padding: 20px 30px;
  gap: 10px;
  justify-content: end;
`;

const StyledInput = styled(Input)`
  display: flex;
  align-items: center;
  background-color: var(--background-gray);
  border: 1px solid var(--line-gray);
  border-radius: 0;
  vertical-align: middle;
  line-height: normal;
  font-size: 14px;
`;

interface Props {
  open: boolean;
  roomType: string;
  unitName: string;
  onConfirm: (unitName: string) => void;
  onClose: () => void;
}

const ShopDataModalAccomodationEditUnitModal = ({ open, roomType, unitName, onConfirm, onClose }: Props) => {
  const onFinish = (values: any) => {
    const trimmedValue = values.unitName?.trim();
    onConfirm(trimmedValue || '');
  };

  const initialValues = {
    unitName: unitName,
  };

  return (
    <StyledModal open={open} footer={null} destroyOnClose onCancel={onClose}>
      <Form initialValues={initialValues} onFinish={onFinish}>
        <Container>
          <Header>
            <Title>Rename Unit</Title>
            <Subtitle>
              for <span>{roomType}</span>
            </Subtitle>
          </Header>
          <Content>
            <Info>Enter a name for this unit. Erase the name if you want to keep it unnamed.</Info>
            <Fields>
              <Field>
                <Label>Unit Name (optional)</Label>
                <Form.Item name={'unitName'} noStyle>
                  <StyledInput placeholder={'Enter unit name (Unit A, Unit B, etc.)'} />
                </Form.Item>
              </Field>
            </Fields>
          </Content>
        </Container>
        <Footer>
          <Button type={'primary'} style={{ fontFamily: 'var(--font-bold)', height: 40, width: 120 }} htmlType="submit">
            Confirm
          </Button>
          <Button style={{ fontFamily: 'var(--font-bold)', height: 40, width: 120 }} onClick={onClose}>
            Cancel
          </Button>
        </Footer>
      </Form>
    </StyledModal>
  );
};

export default ShopDataModalAccomodationEditUnitModal;
